var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Panel',{attrs:{"data":_vm.fee}}),_c('hr'),_c('h3',[_vm._v("Histórico de Multas")]),(_vm.fee && _vm.fee.id)?_c('FeeHistories',{attrs:{"fee":_vm.fee}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }